export { default } from '@shikijs/langs/handlebars'
